import { KeyRound } from "lucide-react";

const ITEMS = [
    "Residential",
    "Commercial",
    "Automotive",
    "24/7 Emergency",
    "Rekeying",
    "Smart Locks",
    "Car Keys",
    "Lock Repair",
];

const Row = ({ ariaHidden = false }) => (
    <div className="flex" aria-hidden={ariaHidden}>
        {ITEMS.map((t, i) => (
            <span key={`${t}-${i}`} className="flex items-center gap-8 pr-8">
                <span className="whitespace-nowrap font-display text-lg italic text-slate-300 sm:text-xl">{t}</span>
                <KeyRound className="h-4 w-4 shrink-0 text-gold" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div data-testid="services-marquee" className="overflow-hidden border-y border-white/10 bg-navy-950 py-5">
        <div className="marquee-track flex w-max">
            <Row />
            <Row ariaHidden />
        </div>
    </div>
);
